import React, { useCallback, useEffect, useState } from "react";
import style from "./Users.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import Pagination from "../../components/paginationCopy/Pagination";
import Search from "../../components/search";
import { PlusOutlined } from "@ant-design/icons";
import {
  disableAgent,
  enableAgent,
  loadAgents,
} from "../../redux/admin/actions/admin.actions";
import CreateForm from "./CreateForm";
import { SortButton } from "../../components/utils/sortButton";

const Users = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [updateModal, setUpdateModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [dataMatch, setDataMatch] = useState();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const { agents } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    setLoading(true);
    dispatch(loadAgents());
    setLoading(false);
  }, [dispatch]);

  const handleRow = (data) => {
    setUpdateModal(true);
    let match = agents?.find((t) => t?.id === data?.id);
    if (match) {
      setDataMatch(match);
    }
  };

  // Search handler
  useEffect(() => {
    setData(
      agents?.filter((id) => {
        return Object.values(id).some((name) =>
          String(name).toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }, [agents, search]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(data?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const updateAgent = (data) => {
    if (data?.status === "1") {
      dispatch(enableAgent(data?.id));
      setUpdateModal(false);
    } else {
      dispatch(disableAgent(data?.id));
      setUpdateModal(false);
    }
  };

  const handleModal = async () => {
    setCreateModal(false);
    dispatch(loadAgents());
  };

  // sorting
  const [sortKey, setSortKey] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");

  function sortData({ tableData, sortKey, reverse }) {
    if (!sortKey) return tableData;

    const sortedData = data.sort((a, b) => {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    });

    if (reverse) {
      return sortedData.reverse();
    }

    return sortedData;
  }

  const sortedData = useCallback(
    () => sortData({ tableData: data, sortKey, reverse: sortOrder === "desc" }),
    [data, sortKey, sortOrder]
  );

  const headers = [
    { key: "index", label: "S/N" },
    { key: "first_name", label: "Name" },
    { key: "username", label: "Username" },
    { key: "email", label: "Email" },
    { key: "class", label: "Class" },
    { key: "state", label: "Location" },
    { key: "status", label: "Status" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };

  return (
    <>
      <div className="d-flex justify-content-between m-3">
        <div className={style.create} onClick={() => setCreateModal(true)}>
          Create <PlusOutlined />
        </div>
        <Search placeholder="Find a user" onChange={handleChange} />
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return (
                  <td key={row.key}>
                    {row.label}{" "}
                    <SortButton
                      columnKey={row.key}
                      onClick={() => changeSort(row.key)}
                      {...{ sortOrder, sortKey }}
                    />
                  </td>
                );
              })}
            </tr>
          </thead>
          {data?.length > 0 ? (
            <tbody>
              {sortedData()
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((agent, index) => (
                  <tr className={style.tableBodyRow} key={index}>
                    <td style={{ width: "7vw" }}>
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "15vw" }}>
                      {agent?.first_name} {agent?.last_name}
                    </td>
                    <td style={{ width: "10vw" }}>{agent?.username}</td>
                    <td style={{ width: "15vw" }}>{agent?.email}</td>
                    <td>{agent?.class}</td>
                    <td>{agent?.state}</td>
                    <td
                      style={{ width: "7vw", cursor: "pointer" }}
                      className="d-flex align-items-center align-items-center"
                      onClick={() => handleRow(agent)}
                    >
                      {agent?.status === "0" ? (
                        <div
                          style={{
                            background: "lightGreen",
                            padding: "5px",
                            color: "white",
                            borderRadius: "5px",
                            display: "flex",
                            justifyContent: "center",
                            width: "6vw",
                          }}
                        >
                          Active
                        </div>
                      ) : (
                        <div
                          style={{
                            background: "#ff726f",
                            padding: "5px",
                            color: "white",
                            borderRadius: "5px",
                            display: "flex",
                            justifyContent: "center",
                            width: "6vw",
                          }}
                        >
                          Inactive
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              No record found
            </div>
          )}
        </Table>
        {data?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* DIALOG MODAL */}
      <ConfirmationModal
        open={createModal}
        handleClose={() => setCreateModal(false)}
        closemodal={() => setCreateModal(false)}
        bgcolor="white"
        width="55vw"
        instruction={
          <CreateForm
            onClickYes={() => {
              handleModal();
            }}
          />
        }
      />

      {/* Update user Status */}
      <ConfirmationModal
        open={updateModal}
        handleClose={() => setUpdateModal(false)}
        closemodal={() => setUpdateModal(false)}
        bgcolor="white"
        width="20vw"
        instruction={
          <div className="d-flex gap-4 justify-content-center align-items-center">
            <button
              className={style.track}
              style={{
                background: dataMatch?.status === "0" ? "#b9303" : "darkGreen",
              }}
              onClick={() => updateAgent(dataMatch)}
            >
              {dataMatch?.status === "0" ? "Deactivate" : "Activate"}
            </button>
          </div>
        }
      />
    </>
  );
};

export default Users;
